<template>
  <div>
    <v-tooltip bottom v-if="tooltipText">
      <template v-slot:activator="{ on: tooltip }">
        <div v-on="{ ...tooltip }">
          <v-btn
            :class="button1Class"
            :small="button1Small"
            :color="button1Color"
            :icon="button1Icon"
            :disabled="disabled"
            @click.stop="dialog = true"
          >
            {{ buttonText }}
            <v-icon>{{ buttonIcon }}</v-icon>
          </v-btn>
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <v-btn
      v-else
      :class="button1Class"
      :small="button1Small"
      :color="button1Color"
      :icon="button1Icon"
      :disabled="disabled"
      @click.stop="dialog = true"
    >
      {{ buttonText }}
      <v-icon>{{ buttonIcon }}</v-icon>
    </v-btn>

    <DragForm v-model="dialog">
      <v-card width="500px">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>

        <v-card-text>
          {{ dialogText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="onCancel">
            {{ cancelText }}
          </v-btn>

          <v-btn color="green darken-1" text @click="onOk">
            {{ okText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>
<script>
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  props: {
    button1Class: {
      type: String,
      default: 'mr-1',
    },
    button1Icon: {
      type: Boolean,
      default: true,
    },
    button1Small: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    button1Color: {
      type: String,
      default: 'primary',
    },
    dialogMaxWidth: {
      type: String,
      default: '400px',
    },
    tooltipText: {
      type: String,
      defaultItem: null,
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogText: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: 'Agree',
    },
    cancelText: {
      type: String,
      default: 'Disagree',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    onOk() {
      this.$emit('ok');

      this.dialog = false;
    },
    onCancel() {
      this.$emit('cancel');

      this.dialog = false;
    },
  },
};
</script>
